module.exports = __webpack_public_path__ + "fj.svg?caf72f69ced8ffea30cc3a38bcc6011e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/fj.svg
// module id = 1095
// module chunks = 0